import moment from 'moment';
import * as types from '../../constants/actionsType'

const initialState = {
  isTrakZoLiteLoading: false,
  trakzoLite: {
    head: [
      {
        label: 'Employee Name',
        align: 'left',
      },
      {
        label: 'Business Unit',
        align: 'left',
      },
      {
        label: 'Department',
        align: 'left',
      },
      {
        label: 'Location',
        align: 'left',
      },
      {
        label: 'Team',
        align: 'left',
      },
      {
        label: 'Date',
        align: 'center',
      },
      {
        label: 'Check In',
        align: 'right'
      },
      {
        label: 'Check Out',
        align: 'right'
      },
     
    ],
    body: []
    },
  
}
const reducer = (state = initialState, action) => {
  switch (action.type) {

    case types.SUCCESS_TRAKZO_LITE:
      var data = action.data.map(i => {
        return [ { isAvatar: true, name: i.employeeName, avatar: i.profileImage },i.businessUnit,i.department,i.location, i.team, i.date, i.checkIn, i.checkOut]
      })
      // console.log(data)
      return {
        ...state,
        trakzoLite: {
          head: [
            {
              label: 'Employee Name',
              align: 'left',
            },
            {
              label: 'Business Unit',
              align: 'left',
              isFilter: true, filterVal: null , index: 1
            },
            {
              label: 'Department',
              align: 'left',
              isFilter: true, filterVal: null , index: 2
            },
            {
              label: 'Location',
              align: 'left',
              isFilter: true, filterVal: null , index: 3
            },
            {
              label: 'Team',
              align: 'left',
              isFilter: true, filterVal: null , index: 4
            },
            {
              label: 'Date',
              align: 'center',
            },
            {
              label: 'Check In',
              align: 'right'
            },
            {
              label: 'Check Out',
              align: 'right'
            },
           
          ],
          body: data
        },
      }
    case types.FAILED_TRAKZO_LITE:
      return {
        ...state,
        head: [
            {
              label: 'Employee Name',
              align: 'left',
            },
            {
              label: 'Business Unit',
              align: 'left',
            },
            {
              label: 'Department',
              align: 'left',
            },
            {
              label: 'Location',
              align: 'left',
            },
            {
              label: 'Team',
              align: 'left',
            },
            {
              label: 'Date',
              align: 'center',
            },
            {
              label: 'Check In',
              align: 'right'
            },
            {
              label: 'Check Out',
              align: 'right'
            },
          ],
        body: []
      }
      case types.LOADING_TRAKZO_LITE:{
          return {
              ...state,
              isTrakZoLiteLoading: action.data
          }
      }
    default:
      return state
  }
}
export default reducer